import history from './historyObject';

const locationToArgs = ({ pathname, search, hash, state }) => (
  [`${pathname}${search}${hash}`, state]
);

export const replaceHistoryState = () => history.replace(...locationToArgs(history.location));

export const pushHistoryState = () => history.push(...locationToArgs(history.location));



// WEBPACK FOOTER //
// ./app/utils/history/index.js